import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dot", "spinner"]
  static values = {
    url: String,
    status: String,
  }

  connect() {
    if (this.statusValue === "pending" || this.statusValue === "downloading") {
      this.poll()
    }
  }

  disconnect() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
      })

      if (response.ok) {
        const data = await response.json()
        this.updateDot(data.color)
        this.statusValue = data.status

        if (data.status === "pending" || data.status === "downloading") {
          this.timer = setTimeout(() => this.poll(), 2000)
        } else if (data.status === "published") {
          // Reload the page to show the updated release in the channel table
          window.location.reload()
        }
      }
    } catch {
      this.timer = setTimeout(() => this.poll(), 5000)
    }
  }

  startSpin() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("animate-spin")
    }
  }

  updateDot(color) {
    const colorMap = {
      green: "bg-green-500",
      amber: "bg-amber-500",
      red: "bg-red-500",
      gray: "bg-gray-300",
    }

    this.dotTargets.forEach((dot) => {
      dot.classList.remove(
        "bg-green-500",
        "bg-amber-500",
        "bg-red-500",
        "bg-gray-300",
      )
      dot.classList.add(colorMap[color] || colorMap.gray)
    })
  }
}
